export default class Binding {
  constructor(b) {
    this.elementBindings = [];
    this.value = b.object[b.property];

    Object.defineProperty(b.object, b.property, {
      get: this.valueGetter.bind(this),
      set: this.valueSetter.bind(this)
    });

    b.object[b.property] = this.value;
  }

  valueGetter() { return this.value };
  valueSetter(val) {
    this.value = val;
    this.elementBindings.forEach((binding) => binding.element[binding.attribute] = val);
  }

  addBinding(element, attribute, event) {
    let binding = {
      element: element,
      attribute: attribute
    };

    if (event){
      element.addEventListener(event, () => this.valueSetter(element[attribute]));
      binding.event = event;
    }

    this.elementBindings.push(binding);
    element[attribute] = this.value;
    return this;
  }
}